const PRODUCTION_URL = `https://retail.pos.api.ansoftt.com:2288/v1`;

export const BASE_URL = PRODUCTION_URL
